import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  Text,
} from '@chakra-ui/react';
import { Form, FormikProps } from 'formik';
import React from 'react';
import FormLabel from '~/components/FormLabel/FormLabel';
import { TagSelect } from '~/components/TagSelect';

import { TagSuggestion } from '../components';
import {
  MAX_CHARACTERS,
  TAG_PREFIX,
  TAG_SUGGESTIONS,
} from './ContentStrengths.constants';
import { ContentStrengthsValues } from './ContentStrengths.types';

export const ContentStrengths = React.forwardRef<
  HTMLFormElement,
  FormikProps<ContentStrengthsValues>
>(({ errors, handleSubmit, setValues, values }, ref) => {
  const suggestedTags = TAG_SUGGESTIONS.filter(
    (tag) => !values.contentStrengths?.includes(tag),
  );
  return (
    <>
      <Form onSubmit={handleSubmit} ref={ref}>
        <FormControl
          id="contentStrengths"
          isInvalid={!!errors.contentStrengths}
          marginBottom={6}
        >
          <Box marginBottom={3}>
            <FormLabel display="inline" fontWeight={400} fontSize="md">
              What content types can you deliver for brands?
            </FormLabel>

            <Text display="inline" color="primary.300" fontSize="sm">
              Highlight 2-4. (Max. 15 characters each)
            </Text>
          </Box>

          <TagSelect
            maxCharacters={MAX_CHARACTERS}
            onChange={(tags) => setValues({ contentStrengths: tags })}
            prefix={TAG_PREFIX}
            tagProps={{
              _active: { backgroundColor: 'primary.500' },
              _hover: { backgroundColor: 'primary.600' },
              colorScheme: 'primary',
              backgroundColor: 'primary.700',
              variant: 'solid',
            }}
            tags={values.contentStrengths ?? []}
            textSubmitButton="Add Content"
          >
            {({ handleAdd, renderUI }) => (
              <>
                <Box marginBottom={4}>
                  {renderUI()}

                  <FormErrorMessage data-testid="error-tags">
                    {errors.contentStrengths}
                  </FormErrorMessage>
                </Box>

                {!!suggestedTags.length && (
                  <>
                    <Text color="primary.300" fontSize="xs">
                      Or add from these:
                    </Text>

                    <Flex flexWrap="wrap" marginX={-1}>
                      {suggestedTags.map((tag) => (
                        <TagSuggestion
                          key={`suggestion-${tag}`}
                          data-testid={`suggestion-${tag}`}
                          onClick={() => handleAdd(tag)}
                        >
                          {tag}
                        </TagSuggestion>
                      ))}
                    </Flex>
                  </>
                )}
              </>
            )}
          </TagSelect>
        </FormControl>
      </Form>
    </>
  );
});
